import { useQuery } from '@apollo/client';
import { ERROR_CODES } from '../errorCodes/errorCodes';
import { GET_STATS_VIDEO } from './apiQueries/video/getStatsVideo';

// given an array of plays, return all players associated with that play
export const useGetStatsVideo = (
  selectedTeamId,
  selectedPlayerId,
  statName,
  selectedPosition,
  gameId,
) => {
  const { data, loading, error } = useQuery(GET_STATS_VIDEO, {
    context: {
      headers: {
        'Accept-Version': 'v2023q2',
      },
    },
    skip:
      !statName || !selectedPlayerId || !selectedTeamId || !selectedPosition,
    variables: {
      statName,
      teamId: parseInt(selectedTeamId, 10),
      playerId: parseInt(selectedPlayerId, 10),
      position: selectedPosition,
      gameId: gameId ? parseInt(gameId, 10) : null,
    },
  });

  if (loading) {
    return { isLoading: loading };
  }

  if (error || data?.statsVideo?.length === 0) {
    console.error(ERROR_CODES.GET_PLAY_PLAYERS, error);
    return {
      isLoading: false,
      hasError: true,
      data: error,
    };
  }

  return {
    isLoading: false,
    data,
  };
};
